import "./App.css";
import Home from "./Components/Home";
import SplashCursor from "../src/Reactbits/SplashCursor/SplashCursor";
import Project from "./Components/Project";
import About from "./Pages/About";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Apidata from "./Components/Apidata";
import Portfolio from "./Pages/Portfolio";
import Contact from "./Pages/Contact";
import Service from "./Pages/Service";


function App() {
  return (
    <>
      {/* <SplashCursor /> */}
      <Header />
   
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service" element={<Service />} />
 

      </Routes>
    </>
  );
}

export default App;
